import React, { FC, useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import ReactPlayer from 'react-player';

import Icon from '../../Icon';

import { IMultimediaGallerySliderItem } from './interfaces';

import './styles.scss';

// list carrousel multimedia item
const MultimediaGallerySliderItem: FC<IMultimediaGallerySliderItem> = ({
  current,
  abstract,
  index,
  image,
  subtype,
  url
}) => {
  const [ pause, setPause ] = useState<boolean>(false);
  const [ videoBg, setVideoBg ] = useState<any>({});

  // get data
  const getData = useCallback(async (url: string) => {
    if (!url) return false;

    const origin = encodeURI(window.location.origin);

    return await axios.get(`https://www.youtube.com/oembed?url=${url}&format=json&origin=${origin}`)
      .then(({ data }) => data);
  }, []);

  // use effect
  useEffect(() => {
    if (subtype === 'tipo2') {
      getData(url).then((data) => setVideoBg(data));
    }

    if (current.current !== index) {
      setPause(false);
    }
  }, [ current, index, url, setVideoBg, getData, subtype ]);

  return (
    <div
      className="multimedia-gallery-slider-item"
      data-type={subtype}>
      {abstract && 
        <div className="multimedia-gallery-slider-item--info">
          <p className="description">{abstract}</p>
        </div>
      }


      {subtype === 'tipo1'
        && <img
            src={image?.original.src}
            alt="video" />}
      
      {subtype === 'tipo2'
        && <>
            <div
              className="multimedia-gallery-slider-item--bg"
              data-active={pause}
              onClick={() => setPause(!pause)}>
              <img
                className="multimedia-gallery-slider-item--bg--img"
                src={videoBg?.thumbnail_url}
                alt={videoBg?.title} />
              
              <Icon icon="icon-video" />

              <div className="multimedia-gallery-slider-item--info">
                <p className="description">{abstract}</p>
              </div>
            </div>

            <ReactPlayer
              className="multimedia-gallery-slider-item--video"
              height={480}
              width={854}
              playing={pause}
              url={url}
              onEnded={() => setPause(false)} />
          </>}
    </div>
  );
};

export default MultimediaGallerySliderItem;